import React, { Fragment } from "react"
import { Wrapper } from "./styled" 
import GamePanel from "./gamePanel/GamePanel"

export default class Game extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
   const letters = [{id:15,l:'R',x:15,y:20},{id:16,l:'O',x:65,y:12},{id:17,l:'N',x:115,y:22},{id:18,l:'S',x:165,y:16},{id:19,l:'A',x:235,y:25},{id:20,l:'X',x:285,y:31},{id:21,l:'L',x:335,y:18}]
    return (
      <Wrapper>
        <GamePanel letters={letters}/>
      </Wrapper>
    )
  }
}
